export default "__VITE_ASSET__zYmO3Nsp__"